import React from 'react';

export const ICON_MAP = {
  layer: 'M1 8L8 11L15 8M1 11L8 14L15 11M8 2L14 5L8 8L2 5L8 2Z',
  layerInactive: 'M14 2H2V14H14V2Z',
  layerActive:
    'M14 2H2V14H14V2ZM12.5 8C12.5 5.5 10.4062 3.5 8 3.5C5.59375 3.5 3.5 5.5 3.5 8C3.5 10.5 5.5 12.5 8 12.5C10.5 12.5 12.5 10.5 12.5 8Z M9.5 8C9.5 7 9 6.5 8 6.5C7 6.5 6.5 7 6.5 8C6.5 9 7 9.5 8 9.5C9 9.5 9.5 9 9.5 8Z',
  eyeOpen:
    'M9 7.99998C9 8.55227 8.55228 8.99998 8 8.99998C7.44772 8.99998 7 8.55227 7 7.99998C7 7.4477 7.44772 6.99998 8 6.99998C8.55228 6.99998 9 7.4477 9 7.99998ZM8 5C6 5 4 6 2 8C4 10 6 11 8 11C10 11 12 10 14 8C12 6 10 5 8 5Z',
  eyeClosed: 'M12 2L4 14M2 8.00002C4 6.00002 6 5.00002 8 5.00002C10 5.00002 12 6.00002 14 8.00002C12 10 10 11 8 11C6 11 4 10 2 8.00002Z',
  link:
    'M9.06065 8.14645L7.64643 6.73224C7.64643 6.73224 6.93933 6.02513 6.23222 6.73224L2.69669 10.2678C1.98958 10.9749 2.69669 11.682 2.69669 11.682L4.1109 13.0962C4.81801 13.8033 5.52511 13.0962 5.52511 13.0962L6.93933 11.682M6.93933 8.85356L8.35354 10.2678C8.35354 10.2678 9.06065 10.9749 9.76775 10.2678L13.3033 6.73224C14.0104 6.02513 13.3033 5.31802 13.3033 5.31802L11.8891 3.90381C11.182 3.1967 10.4749 3.90381 10.4749 3.90381L9.06065 5.31802',
  plus: 'M4 8h8M8 4v8',
  // Entity kinds
  residential: 'M3 8V14H13V8L8 2.5L3 8Z',
  work: 'M6 3H11M6 5H11M6 7H11M6 9H11M6 11H11M6.5 14V13H10.5V14M5 15V1H12V15H5Z',
  road: 'M3 2V14M13 2V14M8 2V5M8 6V10M8 11V14',
  park: 'M5 14V10M5 10H9L5 2L1 10H5Z',
  public: 'M1 13V7M1 7V1H8V7H1Z',
};

export default function Icon({ className, name, onClick, size }) {
  size = size || 16;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 16 16" onClick={() => onClick && onClick()}>
      <path d={ICON_MAP[name]} fill="none" stroke="#c4c4c4" />
    </svg>
  );
}
